<template>
  <div v-if="itinerary" class="itinerary-main">
    <div v-if="!hasPaid" class="d-none d-md-block">
      <!-- Tablet/Desktop Wedding abroad message -->
      <div v-if="isWedding === 'true'" class="congratulations-block">
        <div class="congratulations-text">
          Congratulations and thank you for giving Trailfinders the opportunity
          to help plan your wedding abroad. We have been organising tailormade
          travel for over 50 years and know the importance of getting your
          wedding abroad perfectly right for you. From beach to mountain, jungle
          to desert, across all seven continents, we have seen and done it all
          and are confident we can give you a trip to remember.
        </div>
        <div class="congratulations-text">
          If you have guests joining you, why not let Trailfinders take the
          hassle away by suggesting we arrange their trip to tie in with yours
          at the right moment? The icing on the cake? Why not consider having
          your friends and family help you on your way by using our
          <a :href="wishlistLink" target="_blank">Wishlist</a>
          service?
        </div>
      </div>
      <!-- Tablet/Desktop Honeymoon message -->
      <div
        v-if="honeymoon === 'true' && isWedding !== 'true'"
        class="congratulations-block"
      >
        <div class="congratulations-text">
          Congratulations and thank you for giving Trailfinders the opportunity
          to help plan your honeymoon. We have been organising honeymoons for
          over 50 years and know the importance of getting yours perfectly right
          for you. From beach to mountain, jungle to desert, across all seven
          continents, we have seen and done it all and are confident we can give
          you a trip to remember. Why not consider having your friends and
          family help you on your way by using our
          <a :href="wishlistLink" target="_blank">Honeymoon Wishlist</a>
          service?
        </div>
      </div>
    </div>

    <div v-if="destination !== 'INS'" class="itinerary-btns-container">
      <div class="welcome-btns-container">
        <button
          v-if="bookingInfo.NEWTOTF === 'true'"
          type="button"
          class="btn welcome-btn"
          @click="$refs.VideoModalRef.showModal()"
        >
          <i class="material-icons mr-2">videocam</i>
          <span>Welcome to Trailfinders</span>
        </button>

        <div v-if="displayAtolButton">
          <button
            class="btn welcome-btn"
            @click="getAtolCertificate"
          >
            <i class="icon-atol atol-icon-size pr-2" />
            <span>Your ATOL Certificate</span>
          </button>
        </div>
        <AtolCertificate ref="AtolCertificateRef" />

        <button
          v-if="displayAtolProtected"
          disabled
          class="btn welcome-btn atol-protected"
        >
          <i class="icon-atol atol-icon-size pr-2" />
          <span>This booking is ATOL Protected</span>
        </button>
      </div>
      <!-- SHARE BTNS -->
      <div
        v-if="!friendFamily"
        class="share-btns-container"
        :class="[hasNoWelcomeBtns ? 'w-100' : '']"
      >
        <!-- Gallery -->
        <div
          v-b-tooltip.hover
          title="Gallery"
          class="gallery-btn"
          @click.prevent="openImageGallery"
        >
          <i class="icon-gallery glyph-md" />
        </div>
        <!-- Share with friends & family -->
        <div
          v-b-tooltip.hover
          class="friends-family-btn"
          title="Forward to family &amp; friends"
          @click.prevent="openSendFriendsFamilyModal"
        >
          <i class="icon-send glyph-md" />
        </div>
        <!-- Printer icon -->
        <div
          v-b-tooltip.hover
          title="Printer friendly"
          class="print-btn"
          @click.prevent="
            () => {
              $refs.LoginTokenRef.authCheckResult(() => {
                onPrinterFriendly();
              });
            }
          "
        >
          <i class="icon-printer_friendly glyph-md" />
        </div>
        <!-- Trip Costs (main OR provs that have paid something) -->
        <div
          v-if="
            (accountInfo.fil === 'M' &&
              accountInfo.balanceCostNoSymbol !== '0.00') ||
            (accountInfo.fil === 'P' && hasPaid)
          "
          v-b-tooltip.hover
          title="Trip costs &amp; payment"
          class="costs-btn"
        >
          <router-link :to="{ name: 'payment-hub-landing' }" class="costs-link">
            <i class="icon-payment glyph-md" />
          </router-link>
        </div>
        <!-- Booking Receipt/Invoice -->
        <div
          v-if="summary"
          v-b-tooltip.hover
          title="Booking Invoice / Receipt"
          class="inv-receipt-btn"
          @click.prevent="
            () => {
              $refs.LoginTokenRef.authCheckResult(() => {
                onPrinterFriendlyInvoice();
              });
            }
          "
        >
          <i class="icon-booking_invoice glyph-md" />
        </div>
        <!-- Destination Advice -->
        <div
          v-b-tooltip.hover
          title="Destination Advice"
          class="d-advice-btn"
          @click.prevent="openDestinationAdviceModal()"
        >
          <i class="material-icons glyph-md">language</i>
        </div>
      </div>
      <!-- FILTER OPTIONS -->
      <div class="itinerary-filter d-flex col-sm-3 align-content-center">
        <div class="itinerary-filter-btns">
          <b-form-select
            id="filter-select"
            v-model="displaySelected"
            class="filter-select"
            :options="itineraryItems"
            @change="handleSelect(displaySelected)"
          >
            <template #first>
              <b-form-select-option value="" disabled>
                -- Select to Filter --
              </b-form-select-option>
            </template>
          </b-form-select>
        </div>
      </div>
    </div>
    <b-row
      v-for="(day, index) in itinerary.items"
      :key="index"
      :set="(showRow = false)"
    >
      <b-col v-if="dayContainsServiceToShow(day)">
        <b-row class="itinerary-time-date-container">
          <span
            v-if="!day.tourDay || displayDay(selectedItineraries, day)"
            v-show="checkItineraryDay(day.types, displaySelected)"
            class="itinerary-time-date"
          >
            <i class="material-icons mr-3"></i>{{ day.title_day }}
            {{ day.title_date }}
          </span>
          <span
            v-if="day.tourDay && day.tourDay > 1 && displayDay(selectedItineraries, day)"
            class="itinerary-time-date-tour-day"
          > 
            {{ dayTitle(day.mainBookingId) }} DAY
            {{ day.tourDay }}
          </span>
        </b-row>

        <b-row v-for="(item, index2) in day.data" :key="index2">
          <b-col>
            <Tour
              v-if="item.jsontype === 'tour' && ['View Options', 'Detailed', 'Summary'].indexOf(displaySelected) > -1 && !item.touringHubItem"
              ref="itineraryItemRef"
              :item="item"
            />
            <TourHubMain
              v-if="item.tourhubtype === 'touringhub-main' && ['View Options', 'Detailed', 'Summary', 'Private Tour'].indexOf(displaySelected) > -1"
              :tour-hub-item="item"
              :tour-hub-country-data="tourHubCountryData"
              @toggle-th-show-all="toggleTHShowAll($event)"
            />
            <TourHubService
              v-if="item.tourhubtype === 'touringhub-service' && ['View Options', 'Detailed', 'Summary', 'Private Tour'].indexOf(displaySelected) > -1 && !item.hasOtherTfArrangements"
              :tour-hub-item="item"
              :passenger-info="item.passengerInfo"
              :showAll="tourHubShowAll"
              :selectedItineraries="selectedItineraries"
            />
            <Accommodation
              v-if="
                item.jsontype === 'hotel' &&
                ['View Options', 'Detailed', 'Summary'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
            />

            <Checkin
              v-if="item.jsontype === 'checkin'"
              ref="itineraryItemRef"
              :item="item"
            />

            <Vehicle
              v-if="
                item.jsontype === 'vehicle' &&
                ['View Options', 'Detailed', 'Summary'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
            />

            <Flight
              v-if="
                item.jsontype === 'flight' &&
                ['View Options', 'Detailed', 'Summary', 'Flights Only'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
              :index="index2"
            />

            <Tour
              v-if="
                item.jsontype === 'rail' &&
                ['View Options', 'Detailed', 'Summary'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
            />

            <Transfer
              v-if="
                item.jsontype === 'transfer' &&
                ['View Options', 'Detailed', 'Summary'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
            />

            <Surf
              v-if="
                item.jsontype === 'surf' &&
                ['View Options', 'Detailed', 'Summary'].indexOf(
                  displaySelected
                ) > -1
              "
              ref="itineraryItemRef"
              :item="item"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Notes
          v-if="itinerary.notes && itinerary.notes[0]"
          ref="itineraryItemRef"
          :notes="itinerary.notes"
        />
      </b-col>
    </b-row>

    <!-- MOBILE Wedding/Honeymoon messages -->
    <div
      v-if="isWedding === 'true' || honeymoon === 'true'"
      class="d-block d-md-none mt-5"
    >
      <div class="congratulations-text">
        Why not consider having your friends and family help you on your way by
        using our
        <a :href="wishlistLink" target="_blank">
          {{
            honeymoon === "true" && isWedding !== "true"
              ? "Honeymoon Wishlist"
              : "Wishlist"
          }}
        </a>
        service?
      </div>
    </div>
    <!-- -->
    <div v-if="itinerary.insuranceItem">
      <Insurance
        :item="itinerary.insuranceItem"
        :ins-only="itineraryItems.length"
      />
    </div>
    <div v-if="itinerary.insuranceOptionalItem">
      <InsuranceOptional :item="itinerary.insuranceOptionalItem" />
    </div>
    <div v-if="itinerary.insuranceAmendmentItem">
      <InsuranceAmendment :items="itinerary.insuranceAmendmentItem" />
    </div>
    <div v-if="itinerary.insuranceTopupItem">
      <InsuranceTopupBrick :item="itinerary.insuranceTopupItem" />
    </div>

    <VideoModal
      ref="VideoModalRef"
      title="Welcome to Trailfinders"
      poster="https://cdn.trailfinders.com/4ybaatmm22_new_to_tf1.jpg"
      src="https://vz-0c5f29ad-8d4.b-cdn.net/dc446bc9-5f1f-436e-8362-95a56bca2af1/playlist.m3u8"
    />
    <ForwardFamilyFriends ref="ForwardFamilyFriendsRef" />
    <LoginToken ref="LoginTokenRef" />
    <PrintFriendly ref="PrintFriendlyRef" />
    <DestinationAdviceModal ref="DestinationAdviceModalRef" />

    <LightBox
      :images="itineraryImages ? resizedImages : resizedHero"
      :show="galleryOpen"
      @closeEvent="closeImageGallery"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { ref } from "vue";
import Accommodation from "./items/accommodation";
import Vehicle from "./items/vehicle";
import Checkin from "./items/check-in";
import Flight from "./items/flights/flight";
import Insurance from "./items/insurance/insurance";
import InsuranceAmendment from "./items/insurance/insurance-amendment";
import InsuranceTopupBrick from "./items/insurance/insurance-topup-brick";
import InsuranceOptional from "./items/insurance/insurance-optional";
import Tour from "./items/tour";
import Transfer from "./items/transfer";
import Surf from "./items/surf";
import Notes from "./items/notes";
import VideoModal from "@/modules/video-modal";
import ForwardFamilyFriends from "@/modules/menu-bar/forward-family";
import LoginToken from "@/modules/auth/login-token";
import PrintFriendly from "@/modules/menu-bar/print-friendly";
import LightBox from "@/partials/light-box";
import TourHubMain from "./items/touring-hub/main-brick/index.vue";
import TourHubService from "./items/touring-hub/service-brick/index.vue";
import DestinationAdviceModal from "../../../partials/destination-advice/modals/destination-advice-modal.vue";
import AtolCertificate from "@/modules/booking/atol-certificate/index.vue";
export default {
  components: {
    Accommodation,
    Vehicle,
    Flight,
    Insurance,
    InsuranceAmendment,
    Transfer,
    Surf,
    Notes,
    InsuranceOptional,
    Checkin,
    VideoModal,
    Tour,
    ForwardFamilyFriends,
    LoginToken,
    PrintFriendly,
    LightBox,
    TourHubMain,
    TourHubService,
    DestinationAdviceModal,
    InsuranceTopupBrick,
    AtolCertificate,
  },
  data() {
    return {
      displaySelected: "Detailed",
      index: ref(0),
      galleryOpen: false,
      // FOR TESTING
      touringHubBooking: {},
      isHeaderVisible: false,
      selectedItineraries: [],
      tourHubShowAll: false,
    };
  },
  computed: {
    itineraryItems() {
      return ["Detailed", "Summary", "Flights Only", "Private Tour"];
    },
    ...mapState("booking", ["itineraryImages"]),
    ...mapGetters({
      accountInfo: "booking/getAccount",
      bookingInfo: "booking/getBookingInfo",
      bookingNumber: "booking/getBookingNumber",
      destination: "booking/getDestination",
      friendFamily: "friendFamily/isFriendFamily",
      hero: "booking/getHeroImage",
      honeymoon: "booking/getHoneymoon",
      isWedding: "booking/getWeddingAbroad",
      itinerary: "booking/getItinerary",
      summary: "booking/hasBookingSummary",
      userData: "auth/getUserData",
    }),
    resizedImages() {
      const w = 1200;
      const q = 60;
      const uniqueUrls = new Set();
      this.itineraryImages.forEach((image) => {
        let url;
        if (image.url) {
          url = new URL(image.url);
        } else {
          url = new URL(image);
        }
        if (url.hostname === "cdn.trailfinders.com") {
          url.searchParams.set("width", w.toString());
          url.searchParams.set("quality", q.toString());
        }
        uniqueUrls.add(url.toString());
      });
      return Array.from(uniqueUrls);
    },
    resizedHero() {
      const w = 1920;
      const q = 100;
      const url = new URL(this.hero.url);
      if (url.hostname === "cdn.trailfinders.com") {
        url.searchParams.set("width", w.toString());
        url.searchParams.set("quality", q.toString());
      }
      return [url.toString()];
    },
    displayAtolButton() {
      return !!(this.bookingInfo &&
        this.bookingInfo.desclinks.indexOf("atol_certificate") !== -1 &&
        !this.friendFamily &&
        this.accountInfo.atol_protected === "TRUE" &&
        this.accountInfo.atol_certifno);

    },
    displayAtolProtected() {
      return this.accountInfo.atol_protected === "TRUE" &&
        this.accountInfo.fil === "P";

    },
    hasPaid() {
      return !(this.accountInfo.paidCost === false ||
        this.accountInfo.paidCost === "£0.00" ||
        this.accountInfo.paidCost === "€0.00");

    },
    hasNoWelcomeBtns() {
      return this.bookingInfo.NEWTOTF === "false" &&
        !this.displayAtolButton &&
        !this.displayAtolProtected;

    },
    wishlistLink() {
      const referer =
        this.bookingInfo.booking_site.toUpperCase() === "IE" ? "ie" : "com";
      return `https://www.trailfinders.${referer}/wishlist#/`;
    },
    tourHubCountryData() {
      let output = [];
      for (let i of this.itinerary.items) {
        for (let d of i.data) {
          if (d.tourhubtype === "touringhub-main" && d.countryData && d.countryData.length > 0) {
            output.push({
              mainBookingId: d._id,
              title: d.countryData[0].content.title || "",
              tourStyle: d.countryData[0].content.countryTourStyle || "Private Tour",
              iconName: 'image_search'
            })
          }
        }
      }
      return output;
    },
  },
  async mounted() {
    this.expandAllTabs();
    if (this.$route.query.pop === "shareTrip") {
      this.openSendFriendsFamilyModal();
    }
    this.$root.$on("toggleShowTouringItinerary", (data) => {
      let tempArray = [...this.selectedItineraries];
      if (data.action === "add") {
        tempArray.push(data.id);
      } else {
        tempArray = tempArray.filter(id => id !== data.id)
      }
      this.selectedItineraries = tempArray;
    });
  },
  methods: {
    expandAllTabs() {
      this.$root.$emit("expandall");
    },
    collapseAllTabs() {
      this.$root.$emit("collapseall");
    },
    checkItineraryDay(types) {
      const typeArr = [
        "tour",
        "hotel",
        "checkin",
        "vehicle",
        "flight",
        "rail",
        "transfer",
        "surf",
        "insurance",
      ];
      return types.every((value) => typeArr.includes(value));
    },
    handleSelect(value) {
      this.selectedItineraries = [];
      this.displaySelected = value;
      value === "Summary" ? this.collapseAllTabs() : this.expandAllTabs();
    },
    getAtolCertificate() {
      this.$refs.AtolCertificateRef.getAtolCertificate();
    },
    openSendFriendsFamilyModal() {
      this.$refs["ForwardFamilyFriendsRef"].showModal();
    },
    openImageGallery() {
      this.galleryOpen = !this.galleryOpen;
    },
    closeImageGallery() {
      this.galleryOpen = !this.galleryOpen;
    },
    onPrinterFriendly() {
      this.$refs.PrintFriendlyRef.getPrinterFriendlyPDF();
    },
    onPrinterFriendlyInvoice() {
      this.$refs.PrintFriendlyRef.getPrinterFriendlyInvoicePDF();
    },
    openDestinationAdviceModal() {
      this.$refs.DestinationAdviceModalRef.showDestinationAdviceModal();
    },
    displayDay(ids, _day) {
      let showDay = false;
      _day.data.forEach((item) => {
        if (ids.includes(item.mainBookingId) || item.tourhubtype === 'touringhub-main') {
          showDay = true;
          return
        }
        if (item.tourData){
          showDay = true
        }
      });
      return showDay;
    },
    toggleTHShowAll(data) {
      if (data.type === "summary") {
        this.tourHubShowAll = false;
      }
      if (data.type === "detailed") {
        this.tourHubShowAll = true;
      }
      if (data.type === "printer friendly") {
        this.$refs.PrintFriendlyRef.getPrinterFriendlyTHItineraryPDF(
          data.thId,
          data.uniqueRef
        );
      }
    },
    dayTitle (_id) {
      const match = this.tourHubCountryData.find((el) => el.mainBookingId === _id)
      if (match && match.tourStyle && match.title) {
        return `${match.title} - ${match.tourStyle}`
      }
      return ''
    },
    dayContainsServiceToShow(daysData) {
      /* We want to hide the title day (e.g. MONDAY 22 Oct 2026) for touring hub itineraries where:
      a) the touring hub itinerary has not been 'expanded' yet.
      b) The ONLY service within a day is 'Other arrangements with trailfinders', from the flag hasOtherTfArrangements
      */
     const { data, tourDay } = daysData
     if (!tourDay || tourDay <= 1) return true // non-touring services and 1st day of a touring hub itinerary will always have a date
     
      const dayContainsTfArrangement =  data.some(service => !service.hasOtherTfArrangements)
      if (!dayContainsTfArrangement) return false // day array contains no service items which don't have the 'hasOtherTfArrangements' flag, therefore hide the day

      /* The final check below, will do the following:
        1) Iterate through all services in the day, and return ONLY touring hub services, which are not the 'Other arrangements with trailfinders' cards.
        2) Check the filtered array to see if the day contains either a) the touringhub-main card OR b) a service which is part of the 'expanded' itineraries. If any of these are true, the date will be displayed
      */
      return data
      .filter(serv => serv.touringHubItem && !serv.hasOtherTfArrangements)
      .some((serv) => this.selectedItineraries.includes(serv.mainBookingId) || serv.tourhubtype === 'touringhub-main')
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
